/**
 * en-GB messages added by Phase 2 task K5 (docs/PHASE-2-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const k5EnGB = {
    'kiosk.home.expected': 'I am expected',
    'kiosk.home.scanCode': 'Scan my QR code',
    'kiosk.scan.titleCode': 'Scan your QR code',
    'kiosk.scan.hintCode': 'Hold the QR code from your email, your card or your badge in front of the camera.',
    'kiosk.scan.invalid': 'That QR code is not valid here. Please try again or choose your name from the list.',
    'kiosk.scan.notSupported': 'This kiosk cannot use that kind of QR code. Please choose your name from the list.',
    'kiosk.scan.unknownMember': 'That QR code is not recognised at this kiosk. Please choose your name from the list.',
    'kiosk.scan.oldCode': 'That QR code has been replaced by a new one. Please use the newest one or choose your name.',
    'kiosk.scan.notHere': 'That QR code is not for this kiosk.',
    'kiosk.scan.notExpected': 'We are not expecting that QR code today. Please ask at reception.',
    'kiosk.scan.cancelled': 'That visit has been cancelled. Please ask at reception.',
    'kiosk.scan.alreadyArrived': 'That QR code has already been used to sign in.',
    'kiosk.scan.expired': 'That QR code has expired. Please ask at reception.',
    'kiosk.expected.title': 'Who are you?',
    'kiosk.expected.search': 'Start typing your name',
    'kiosk.expected.exactHint': 'Please type your full name exactly as it was given to us.',
    'kiosk.expected.requiredHint': 'You need to be expected to sign in here. Find your name, or scan your QR code.',
    'kiosk.expected.none': 'We could not find that name on today’s list. Please ask at reception.',
    'kiosk.expected.empty': 'Nobody is expected right now.',
    'kiosk.expected.visiting': 'Visiting {host}',
    'kiosk.expected.required': 'You need to be expected to sign in here. Please ask at reception.',
    'kiosk.signout.outMark': 'Out',
    'kiosk.signout.outToday': 'Signed out today',
    'kiosk.hostReply.on_my_way': '{host} is on their way.',
    'kiosk.hostReply.please_wait': '{host} asks you to please wait.',
    'kiosk.hostReply.someone': 'Your host',
    'kiosk.hostReply.dismiss': 'OK',
};
//# sourceMappingURL=k5.js.map